import React from 'react'
import { getIn, FastField } from 'formik'
import { TextField } from '@material-ui/core'

const changeFields = ['name', 'placeholder']
const formikFields = ['values', 'errors', 'touched']

const shouldUpdate = (newProps, prevProps) => {
  const propsChanged = changeFields.some(f => newProps[f] !== prevProps[f])
  const formikChanged = formikFields.some(
    f =>
      getIn(newProps.formik[f], prevProps.name) !==
      getIn(prevProps.formik[f], prevProps.name)
  )
  if (
    propsChanged ||
    formikChanged ||
    Object.keys(prevProps).length !== Object.keys(newProps).length ||
    newProps.formik.isSubmitting !== prevProps.formik.isSubmitting
  ) {
    return true
  } else {
    return false
  }
}

const FormikTextField = props => {
  const { helperText, name, placeholder, ...rest } = props

  return (
    <FastField
      name={name}
      shouldUpdate={shouldUpdate}
      placeholder={placeholder}
    >
      {({ field, form, meta }) => {
        const { touched, error } = meta
        const { name, value, onChange, onBlur } = field
        const hasError = Boolean(touched && error)
        return (
          <TextField
            {...{ name, value, onChange, onBlur }}
            {...rest}
            minRows={0}
            error={hasError}
            helperText={hasError ? error : helperText}
            placeholder={placeholder}
          />
        )
      }}
    </FastField>
  )
}

FormikTextField.defaultProps = {
  variant: 'filled',
}

export default FormikTextField
